// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as PlApi from "../player/PlApi.bs.js";
import * as React from "react";
import * as Modal0 from "../common/Modal0.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as PlMatchDetails from "./PlMatchDetails.bs.js";
import CircularProgress from "@mui/material/CircularProgress";

function PlExpandedMatch(Props) {
  var heroName = Props.heroName;
  var heroTag = Props.heroTag;
  var hoveredMatchId = Props.hoveredMatchId;
  var expandedMatchId = Props.expandedMatchId;
  var onClose = Props.onClose;
  var initialMatchData = Props.initialMatchData;
  var noShare = Props.noShare;
  var match = React.useState(function () {
        if (expandedMatchId === undefined) {
          return ;
        }
        if (initialMatchData === undefined) {
          return ;
        }
        var data = Caml_option.valFromOption(initialMatchData);
        if (expandedMatchId === data.id) {
          return Belt_MapString.set(undefined, expandedMatchId, data);
        }
        
      });
  var setMatchesData = match[1];
  React.useEffect((function () {
          if (hoveredMatchId !== undefined) {
            Region.fromApiName(Belt_Array.getExn(hoveredMatchId.split("_"), 0).toLowerCase());
            var cancelled = {
              contents: false
            };
            $$Promise.consume(PlApi.getMatch(hoveredMatchId), (function (matchInfo) {
                    if (!cancelled.contents) {
                      return Curry._1(setMatchesData, (function (md) {
                                    return Belt_MapString.set(md, hoveredMatchId, matchInfo);
                                  }));
                    }
                    
                  }));
          }
          
        }), [hoveredMatchId]);
  React.useEffect((function () {
          if (expandedMatchId !== undefined) {
            Region.fromApiName(Belt_Array.getExn(expandedMatchId.split("_"), 0).toLowerCase());
            var cancelled = {
              contents: false
            };
            $$Promise.consume(PlApi.getMatch(expandedMatchId), (function (matchInfo) {
                    if (!cancelled.contents) {
                      return Curry._1(setMatchesData, (function (md) {
                                    return Belt_MapString.set(md, expandedMatchId, matchInfo);
                                  }));
                    }
                    
                  }));
          }
          
        }), [expandedMatchId]);
  var matchData = expandedMatchId !== undefined ? Belt_MapString.get(match[0], expandedMatchId) : undefined;
  Belt_Option.isSome(matchData);
  var tmp;
  var exit = 0;
  if (expandedMatchId !== undefined && matchData !== undefined) {
    var matchInfo = Caml_option.valFromOption(matchData);
    var region = Region.fromApiName(Belt_Array.getExn(matchInfo.id.split("_"), 0).toLowerCase());
    var tmp$1 = {
      region: region,
      matchInfo: matchInfo,
      onClose: onClose
    };
    if (heroName !== undefined) {
      tmp$1.heroName = Caml_option.valFromOption(heroName);
    }
    if (heroTag !== undefined) {
      tmp$1.heroTag = Caml_option.valFromOption(heroTag);
    }
    if (noShare !== undefined) {
      tmp$1.noShare = Caml_option.valFromOption(noShare);
    }
    tmp = React.createElement(PlMatchDetails.make, tmp$1);
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = expandedMatchId !== undefined ? React.createElement(ContentSection.make, {
            level: 0,
            children: React.createElement("div", {
                  className: "min-h-[200px] p-4 w-full flex flex-col items-center justify-center"
                }, React.createElement(CircularProgress, {
                      size: 64
                    }), React.createElement("div", {
                      className: "pt-4 text-sm"
                    }, "Loading match data..."))
          }) : null;
  }
  return React.createElement(Modal0.make, {
              opened: Belt_Option.isSome(expandedMatchId),
              onClose: onClose,
              children: tmp,
              padding: "0px !important",
              modalClass: "w-auto",
              innerClass: "sm:flex sm:items-center"
            });
}

var make = PlExpandedMatch;

export {
  make ,
  
}
/* PlApi Not a pure module */
